import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { isChunkLoadError } from '@/lib/chunkReload';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/** Catches render and lazy-chunk failures so the user gets a reload prompt instead of a white screen. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ErrorBoundary caught', error, info.componentStack);
  }

  render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="flex min-h-[50vh] items-center justify-center p-6" role="alert">
        <div className="text-center">
          <p className="text-base font-semibold text-dark dark:text-dark-text">
            {isChunkLoadError(error) ? 'Der er kommet en ny version af Mesterplan.' : 'Noget gik galt.'}
          </p>
          <Button className="mt-4" onClick={() => window.location.reload()}>
            Genindlæs
          </Button>
        </div>
      </div>
    );
  }
}
